<template>
  <div id="container" ref="containerRef">
    <div id="content">
      <div id="title">
        <svg v-if="type === 'bolus'" id="pressor-button" viewBox="0 0 109 70">
          <g
            id="Page-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="Pressor-button">
              <path
                d="M105,0.5 L4,0.5 C3.03350169,0.5 2.15850169,0.891750844 1.52512627,1.52512627 C0.891750844,2.15850169 0.5,3.03350169 0.5,4 L0.5,66 C0.5,66.9664983 0.891750844,67.8414983 1.52512627,68.4748737 C2.15850169,69.1082492 3.03350169,69.5 4,69.5 L105,69.5 C105.966498,69.5 106.841498,69.1082492 107.474874,68.4748737 C108.108249,67.8414983 108.5,66.9664983 108.5,66 L108.5,4 C108.5,3.03350169 108.108249,2.15850169 107.474874,1.52512627 C106.841498,0.891750844 105.966498,0.5 105,0.5 Z"
                id="bg"
                stroke="#373737"
                fill="#D6B3D3"
              />
              <text
                id="Pressor"
                font-family="SegoeUI, Segoe UI"
                font-size="22"
                font-weight="normal"
                fill="#373737"
              >
                <tspan x="19.1582031" y="42">Pressor</tspan>
              </text>
            </g>
          </g>
        </svg>
        <svg v-if="type === 'iv_up'" id="pressor-button" viewBox="0 0 127 81">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-4.000000, -3.000000)">
              <path
                d="M70.9523294,5.56487692 C69.7700201,4.61154247 68.3132247,4.22768567 66.9136731,4.37773982 C65.5141214,4.52779396 64.1718135,5.21175906 63.2184791,6.39406842 L5.63908668,77.8030631 C5.13732376,78.425341 4.86369091,79.2006278 4.86369091,80 C4.86369091,80.9664983 5.25544176,81.8414983 5.88881718,82.4748737 C6.5221926,83.1082492 7.3971926,83.5 8.36369091,83.5 L126.636309,83.5 C127.435681,83.5 128.210968,83.2263672 128.833246,82.7246042 C129.585625,82.1179369 130.020875,81.2637409 130.116364,80.3731171 C130.211853,79.4824934 129.967581,78.5554418 129.360913,77.8030631 L71.7815209,6.39406842 C71.535463,6.08891155 71.2574863,5.81093482 70.9523294,5.56487692 Z"
                stroke="#373737"
                fill="#D6B3D3"
              />
              <text
                font-family="SegoeUI, Segoe UI"
                font-size="22"
                font-weight="normal"
                fill="#373737"
              >
                <tspan x="31.1582031" y="69">Pressor</tspan>
              </text>
              <path
                d="M57,29 L51.0572871,29 C50.5050023,29 50.0572871,28.5522847 50.0572871,28 C50.0572871,27.7795037 50.1301633,27.5651896 50.2645778,27.3904002 L65.1498603,8.03392832 C66.1598783,6.72052454 68.0433839,6.47458183 69.3567877,7.4845999 C69.5619663,7.64238392 69.7458629,7.82605749 69.9038957,8.03104454 L84.8280657,27.3894389 C85.1652693,27.8268314 85.0840501,28.4547656 84.6466576,28.7919692 C84.4717023,28.9268493 84.2570083,29 84.0360965,29 L79,29 L79,38 C79,38.5522847 78.5522847,39 78,39 L58,39 C57.4477153,39 57,38.5522847 57,38 L57,29 Z"
                fill="#373737"
              />
            </g>
          </g>
        </svg>
        <svg v-if="type === 'iv_down'" id="pressor-button" viewBox="0 0 127 81">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-4.000000, -1.000000)">
              <g
                transform="translate(67.500000, 42.500000) scale(1, -1) translate(-67.500000, -42.500000) "
              >
                <path
                  d="M70.9523294,5.56487692 C69.7700201,4.61154247 68.3132247,4.22768567 66.9136731,4.37773982 C65.5141214,4.52779396 64.1718135,5.21175906 63.2184791,6.39406842 L5.63908668,77.8030631 C5.13732376,78.425341 4.86369091,79.2006278 4.86369091,80 C4.86369091,80.9664983 5.25544176,81.8414983 5.88881718,82.4748737 C6.5221926,83.1082492 7.3971926,83.5 8.36369091,83.5 L126.636309,83.5 C127.435681,83.5 128.210968,83.2263672 128.833246,82.7246042 C129.585625,82.1179369 130.020875,81.2637409 130.116364,80.3731171 C130.211853,79.4824934 129.967581,78.5554418 129.360913,77.8030631 L71.7815209,6.39406842 C71.535463,6.08891155 71.2574863,5.81093482 70.9523294,5.56487692 Z"
                  stroke="#373737"
                  fill="#D6B3D3"
                />
                <path
                  d="M57,29 L51.0572871,29 C50.5050023,29 50.0572871,28.5522847 50.0572871,28 C50.0572871,27.7795037 50.1301633,27.5651896 50.2645778,27.3904002 L65.1498603,8.03392832 C66.1598783,6.72052454 68.0433839,6.47458183 69.3567877,7.4845999 C69.5619663,7.64238392 69.7458629,7.82605749 69.9038957,8.03104454 L84.8280657,27.3894389 C85.1652693,27.8268314 85.0840501,28.4547656 84.6466576,28.7919692 C84.4717023,28.9268493 84.2570083,29 84.0360965,29 L79,29 L79,29 L79,38 C79,38.5522847 78.5522847,39 78,39 L58,39 C57.4477153,39 57,38.5522847 57,38 L57,29 L57,29 Z"
                  fill="#373737"
                />
              </g>
              <text
                font-family="SegoeUI, Segoe UI"
                font-size="22"
                font-weight="normal"
                fill="#373737"
              >
                <tspan x="31.1582031" y="26">Pressor</tspan>
              </text>
            </g>
          </g>
        </svg>
        <svg v-if="type === 'iv_off'" id="pressor-button" viewBox="0 0 127 81">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-4.000000, -1.000000)">
              <g
                transform="translate(67.500000, 42.500000) scale(1, -1) translate(-67.500000, -42.500000) "
              >
                <path
                  d="M70.9523294,5.56487692 C69.7700201,4.61154247 68.3132247,4.22768567 66.9136731,4.37773982 C65.5141214,4.52779396 64.1718135,5.21175906 63.2184791,6.39406842 L5.63908668,77.8030631 C5.13732376,78.425341 4.86369091,79.2006278 4.86369091,80 C4.86369091,80.9664983 5.25544176,81.8414983 5.88881718,82.4748737 C6.5221926,83.1082492 7.3971926,83.5 8.36369091,83.5 L126.636309,83.5 C127.435681,83.5 128.210968,83.2263672 128.833246,82.7246042 C129.585625,82.1179369 130.020875,81.2637409 130.116364,80.3731171 C130.211853,79.4824934 129.967581,78.5554418 129.360913,77.8030631 L71.7815209,6.39406842 C71.535463,6.08891155 71.2574863,5.81093482 70.9523294,5.56487692 Z"
                  stroke="#373737"
                  fill="#D6B3D3"
                />
              </g>
              <text
                font-family="SegoeUI, Segoe UI"
                font-size="30"
                font-weight="normal"
                fill="#373737"
              >
                <tspan x="65" y="56" text-anchor="middle">Off</tspan>
              </text>
              <text
                font-family="SegoeUI, Segoe UI"
                font-size="22"
                font-weight="normal"
                fill="#373737"
              >
                <tspan x="31.1582031" y="26">Pressor</tspan>
              </text>
            </g>
          </g>
        </svg>
        <svg id="title-svg" viewBox="0 0 100 100">
          <g>
            <text
              v-if="type === 'bolus'"
              class="title-text"
              x="0"
              y="52"
              font-family="SegoeUI, Segoe UI"
              font-size="10"
              font-weight="normal"
              fill="#00413B"
            >
              Add Bolus Marker
            </text>
            <text
              v-if="type === 'iv_up'"
              class="title-text"
              x="0"
              y="48"
              font-family="SegoeUI, Segoe UI"
              font-size="10"
              font-weight="normal"
              fill="#00413B"
            >
              <tspan>Add Infusion Rate</tspan>
              <tspan x="0" dy="1.2em">Increase Marker</tspan>
            </text>
            <text
              v-if="type === 'iv_down'"
              class="title-text"
              x="0"
              y="48"
              font-family="SegoeUI, Segoe UI"
              font-size="10"
              font-weight="normal"
              fill="#00413B"
            >
              <tspan>Add Infusion Rate</tspan>
              <tspan x="0" dy="1.2em">Decrease Marker</tspan>
            </text>
            <text
              v-if="type === 'iv_off'"
              class="title-text"
              x="0"
              y="48"
              font-family="SegoeUI, Segoe UI"
              font-size="10"
              font-weight="normal"
              fill="#00413B"
            >
              <tspan>Add Infusion</tspan>
              <tspan x="0" dy="1.2em">Stopped Marker</tspan>
            </text>
          </g>
        </svg>
      </div>
      <RadioSet ref="radioset" :options="options" v-model="selected"></RadioSet>
      <div id="buttons">
        <svg
          id="buttons-desc"
          viewBox="0 0 7.8 1"
          preserveAspectRatio="xMinYMin"
        >
          <text x="0" y="0.5" font-size="0.31">
            <tspan x="0.5">
              This will add a marker for {{ selected.name }}
            </tspan>
            <tspan x="0.5" dy="0.4">
              {{ therapyTypeDesc }} at {{ time }} to the timeline
            </tspan>
          </text>
        </svg>
        <div id="ok-cancel">
          <button class="button" @click="clickOK">
            <svg viewBox="0 0 10 10" preserveAspectRatio="xMidYMid">
              <text x="3.5" y="2.4" font-size="2">OK</text>
            </svg>
          </button>
          <button class="button" @click="clickClose">
            <svg viewBox="0 0 10 10" preserveAspectRatio="xMidYMid">
              <text x="2" y="2.4" font-size="2">Cancel</text>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <svg id="close" viewBox="0 0 40 39" @click="clickClose">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g>
          <rect id="bg" fill="#00413B" x="0" y="0" width="100%" height="100%" />
          <polygon
            id="Path"
            fill="#FFFFFF"
            points="9 2 20.013 15.845 31.0275928 2 36.0275928 2 22.509 18.982 36.0275928 35.975305 31.0458031 35.975305 20.013 22.116 8.98178971 35.975305 4 35.975305 17.518 18.982 4 2"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import RadioSet from '@/components/RadioSet'
import { dialogClockMixin } from '@/components/DialogMixin'

export default {
  name: 'TherapyDialog',
  mixins: [dialogClockMixin],
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data() {
    const options = [
      { name: 'Mephentermine (MP)', id: 1, checked: true, shortName: 'MP' },
      { name: 'Dopamine (DP)', id: 2, checked: false, shortName: 'DP' },
      { name: 'Dobutamine (DB)', id: 3, checked: false, shortName: 'DB' },
      { name: 'Ephedrine (EPH)', id: 4, checked: false, shortName: 'EPH' },
      { name: 'Phenylephrine (PE)', id: 5, checked: false, shortName: 'PE' },
      { name: 'Adrenaline (ADR)', id: 6, checked: false, shortName: 'ADR' },
      {
        name: 'Noradrenaline (NAD)',
        id: 7,
        checked: false,
        shortName: 'NAD'
      }
    ]
    return {
      selected: options[0],
      options
    }
  },
  methods: {
    clickClose() {
      this.$emit('close-dialog')
    },
    clickOK() {
      this.$emit('add-marker', this.type, this.selected.shortName)
    },
    onResize() {
      let size = this.$refs.containerRef.clientWidth * 0.035
      this.$refs.radioset.$el.style.fontSize = size + 'px'
    }
  },
  components: {
    RadioSet
  },
  computed: {
    therapyTypeDesc() {
      switch (this.type) {
        case 'bolus':
          return 'Bolus'
        case 'iv_up':
          return 'Infusion Rate Increased'
        case 'iv_down':
          return 'Infusion Rate Decreased'
        case 'iv_off':
          return 'Infusion Stopped'
        default:
          return 'Bolus'
      }
    }
  },
  mounted() {
    // Register an event listener when the Vue component is ready
    window.addEventListener('resize', this.onResize)
    this.$nextTick(() => {
      this.onResize()
    })
  },
  beforeUnmount() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>
text {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
#container {
  position: relative;
  background-color: white;
  border: 2px solid #00413b;
}

#close {
  position: absolute;
  width: 8%;
  height: 8%;
  top: 0;
  right: 0;
  background-color: #00413b;
}

#content {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#title {
  flex: 23%;
  max-height: 23%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

#pressor-button {
  width: 25%;
  margin-left: 2%;
}

#title-svg {
  width: 70%;
  margin-left: 5%;
}

#buttons {
  flex: 22%;
  max-height: 22%;
  display: flex;
  flex-direction: column;
}

#buttons-desc {
  height: 55%;
  width: 89%;
  margin: 0 5% 2% 6%;
}

#ok-cancel {
  height: 40%;
  display: flex;
  justify-content: center;
  padding: 1%;
}
.button {
  border: none;
  background-color: #c4c4c4;
  width: 30%;
  height: 100%;
  box-sizing: border-box;
  margin-left: 4%;
  margin-right: 4%;
}
.button:focus {
  outline: none;
}
#list {
  margin-left: 5%;
}
</style>
